import type { AppState, Components, MealType } from '../types';

export type BalanceStatus = 'ok' | 'light' | 'empty';
export type ComponentName = keyof Components;
export type ComponentBalance = { coverage: number; status: BalanceStatus };
export type Balance = Record<ComponentName, ComponentBalance> & { total: number };

const ALL: ComponentName[] = ['protein', 'grain', 'veggie', 'fruit', 'fat'];

export function computeBalance(state: AppState, weekId: string, mealType?: MealType): Balance {
  const week = state.weeks.find(w => w.id === weekId);
  const filled = (week?.meals ?? []).filter(m => {
    if (!m.recipe_id) return false;
    if (mealType && m.meal_type !== mealType) return false;
    return true;
  });
  const total = filled.length;
  const min = state.settings.smart_suggest_thresholds.component_coverage_min;

  const result = { total } as Balance;
  for (const c of ALL) {
    if (total === 0) {
      result[c] = { coverage: 0, status: 'empty' };
      continue;
    }
    let count = 0;
    for (const m of filled) {
      const r = state.recipes.find(x => x.id === m.recipe_id);
      if (r?.components[c]) count++;
    }
    const coverage = count / total;
    result[c] = { coverage, status: coverage < min ? 'light' : 'ok' };
  }
  return result;
}
